import $ from 'jquery';
import { getState } from '~src/state';
import {
  EDITOR_MODE_ORG_TEMPLATE_MANAGER,
  EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
} from '~config/editorConstants';
import { calculateFormat } from './calculateFormat';
import { getFormatNameAndOrientration } from './getFormatNameAndOrientration';
import { getSelectedFormatId } from './getSelectedFormatId';
import { hideSpinner } from './hideSpinner';
import {
  renderFuneralServiceSelectorInLoader,
  onFuneralServiceSelectedFromLoader,
} from './funeralServiceSelector';
import { initNewServizioForm } from './initNewServizioForm';
import { setServizio } from './setServizio';
import { showSpinner } from './showSpinner';
import { initScrollToTopArrow } from './initScrollToTopArrow';
import { scrollToGo } from './scrollToGo';
import { getMetadata } from './getMetadata';
import { composeMetadataCanvasNavText } from './composeMetadataCanvasNavText';
import { templatesCategoryAutoLoad } from './templatesCategoryAutoLoad';
import { initLoaderClickListeners } from './initLoaderClickListeners';
import { createBlockSticker } from './createBlockSticker';
import { loadingBox } from './loadingBox';
import { scrollToTop } from './scrollToTop';
import {
  switchEditorMode,
  switchEditorModeClickListener,
} from './switchEditorMode';
import { initDatatableServizi } from './initDatatableServizi';

export const localisationOrientation = {
  h: { singular: 'Orizzontale', plural: 'Orizzontali' },
  v: { singular: 'Verticale', plural: 'Verticali' },
};

export const colSizes = {
  regular: 'col-12 col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-2 block-regular',
  xl: 'col-6 col-sm-4 col-md-4 col-lg-4 col-xl-3 block-xl',
};

const generateBlock = (blockContent, size = 'regular') => {
  return `<div class="${colSizes[size]}">${blockContent}</div>`;
};

const loaderBlock = generateBlock(
  '<div class="block-loader mt-3"></div>',
  'regular'
);
const loaderBlockXL = generateBlock(
  '<div class="block-loader block-xl mt-3"></div>',
  'xl'
);

export const scegliServizioBlock = `<div class="${colSizes['regular']} mt-4 block-with-image"
        data-servizio="true"
        data-toggle="modal"
        data-target="#modalEditorServizio">
        <div class="block-image lazy" data-bg="../../assets/blocks/select/servizio.png"></div>
        <div class="block-name">Scegli servizio esistente</div>
</div>`;

export const cambiaServizioBlock = `<div class="${colSizes['regular']} mt-4 block-with-image"
        data-servizio="true"
        data-toggle="modal"
        data-target="#modalEditorServizio">
        <div class="block-image lazy" data-bg="../../assets/blocks/select/servizio.png"></div>
        <div class="block-name">Cambia servizio</div>
  </div>`;

export const aggiungiServizioBlock = `<div class="${colSizes['regular']} mt-4 block-with-image editor-block-new-item"
  data-servizio="true"
  data-toggle="modal"
  data-target="#modalEditorAggiungiServizio">
  <div class="block-image bg-color-servizio lazy" data-bg="../../assets/blocks/new.png"></div>
  <div class="block-name">Crea nuovo servizio</div>
</div>`;

export const enableLoaderInput = () => {
  $('#editor-rendering-input-block').hide();
};

export const disableLoaderInput = () => {
  $('#editor-rendering-input-block').show();
};

export const showContainer = (name) => {
  $(`#container-${name}`).show();
};

export const hideContainer = (name) => {
  $(`#container-${name}`).hide();
};

export const displayLoadingContainer = (
  containerName,
  size = 'regular',
  blocksCount = 1,
  force = false
) => {
  const hasContent = $(`#editor-${containerName}`).html();
  if (force === false && hasContent) {
    return;
  }

  if (size === 'regular') {
    $(`#editor-${containerName}`).html(loaderBlock.repeat(blocksCount));
  } else if (size === 'xl') {
    $(`#editor-${containerName}`).html(loaderBlockXL.repeat(blocksCount));
  }
};

export const doesSelectedProjectRequireFuneral = () => {
  if (
    [
      EDITOR_MODE_ORG_TEMPLATE_MANAGER,
      EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
    ].includes(getState('editorMode'))
  ) {
    return false;
  }
  const tipo = getState('selected.tipo');

  return tipo.isRelatedToFuneral;
};

export const scrollToBottom = () => {
  $('html,body').animate({ scrollTop: 9999 }, 'slow');
};

export const initOnModalServiziEvents = () => {
  $('#modalEditorServizio').on(
    'show.bs.modal',
    renderFuneralServiceSelectorInLoader
  );
};

export const initOnModalCardsEvents = () => {
  $('#modalEditorServizio').on('show.bs.modal', initDatatableServizi);
};

export const toggleEditorHomeMenu = () => {
  $('#editor-main-menu').slideToggle();
  $('.app-spinner').show();
};

export const resizeDimensions = (
  originalWidth,
  originalHeight,
  sourceDPI,
  targetDPI
) => {
  const dpiProportion = sourceDPI / targetDPI;

  const width = Math.round(originalWidth / dpiProportion);
  const height = Math.round(originalHeight / dpiProportion);

  return { width, height };
};

export const getCanvasBaseZoom = (width, height) => {
  const canvasMargin = 25;
  const containerWidth = $('#canvas-container').outerWidth() - canvasMargin;
  const containerHeight = $('#canvas-container').outerHeight() - canvasMargin;

  let canvasWidth = width;
  let canvasHeight = height;
  let zoomValue = 1;

  while (canvasWidth > containerWidth || canvasHeight > containerHeight) {
    canvasWidth = width;
    canvasHeight = height;
    zoomValue = +(zoomValue - 0.01).toFixed(2); // 0.3

    canvasWidth = Math.round(canvasWidth * zoomValue);
    canvasHeight = Math.round(canvasHeight * zoomValue);
  }

  return zoomValue;
};

export {
  getSelectedFormatId,
  initNewServizioForm,
  setServizio,
  getFormatNameAndOrientration,
  calculateFormat,
  hideSpinner,
  showSpinner,
  initScrollToTopArrow,
  scrollToGo,
  getMetadata,
  composeMetadataCanvasNavText,
  templatesCategoryAutoLoad,
  initLoaderClickListeners,
  switchEditorMode,
  switchEditorModeClickListener,
  createBlockSticker,
  loadingBox,
  scrollToTop,
  renderFuneralServiceSelectorInLoader,
  onFuneralServiceSelectedFromLoader,
};
